import React, { useState } from "react";
import { observer } from "mobx-react";
import { DATE_FILTER_LIST } from "../../ReportsModule/constants";
import CustomDateRangePopover from "./CustomDateRangePopover";
import widgetDataStore from "../store/widgetDataStore";

const DateFilter = observer(({ activeFilter, onSelect }) => {
  const [showCustom, setShowCustom] = useState(false);

  return (
    <div className="dateFilter">
      {DATE_FILTER_LIST?.length &&
        DATE_FILTER_LIST.map(item => {
          const { name = "", id = "", value = "" } = item || {};

          if (name === "Custom") {
            return (
              <div key={id} className="customDateFilterWrap">
                <div
                  className={`tabItem ${activeFilter === "custom" ? "active" : ""}`}
                  id={id}
                  onMouseDown={e => e.stopPropagation()}
                  onClick={() => setShowCustom(prev => !prev)}
                >
                  <span>{name}</span>
                </div>
                {showCustom && (
                  <CustomDateRangePopover
                    initialRange={widgetDataStore.activeCustomRange}
                    onApply={range => {
                      widgetDataStore.setCustomDateRange(range);
                      setShowCustom(false);
                    }}
                    onClose={() => setShowCustom(false)}
                  />
                )}
              </div>
            );
          }

          return (
            <div
              className={`tabItem ${activeFilter === value ? "active" : ""}`}
              id={id}
              key={id}
              onClick={() => onSelect(value)}
            >
              <span>{name}</span>
            </div>
          );
        })}
    </div>
  );
});

export default DateFilter;
